import { LandingPage } from "@/components/landing/LandingPage";
import { parentsLandingConfig } from "@/data/landingConfigs";

/**
 * Meta-ads landing page for families / parents
 * (/parents-recus-retours, /en/parents-receipts-returns).
 */
const ParentsLanding = () => <LandingPage config={parentsLandingConfig} />;

export default ParentsLanding;
